import { Route, Routes } from 'react-router-dom';
import PackageCreateContainer from '../../../Containers/Settings/Voss/PackageCreateContainer';
import PackageDetailContainer from '../../../Containers/Settings/Voss/PackageDetailContainer';
import PackagesContainer from '../../../Containers/Settings/Voss/PackagesContainer';

const PackagesLayout = () => (
    <Routes>
        <Route index element={<PackagesContainer />} />
        <Route path="create" element={<PackageCreateContainer />} />
        <Route path=":packageId/*" element={<PackageDetailContainer />} />
    </Routes>
);

export default PackagesLayout;
